import { Brand, createBranded } from '@deltasierra/type-utilities';

export type UploadId = Brand<number, 'UploadId'>;
export const UploadId = createBranded<UploadId>();
